import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';

const HomeWarranties = () => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>Home Warranties</Text>
      <Text style={styles.listItem}>
        At or before settlement, either party may purchase a home warranty for
        the Property from a third-party vendor. Buyer and Seller understand that
        a home warranty for the Property does not alter any disclosure
        requirements of Seller, will not cover or warrant any pre-existing
        defects of the Property, and will not alter, waive or extend any
        provisions of this Agreement regarding inspections or certifications
        that Buyer has elected or waived as part of this Agreement. Buyer and
        Seller understand that a broker who recommends a home warranty may have
        a business relationship with the home warranty company that provides a
        financial benefit to the broker
      </Text>
    </View>
  );
};

export default HomeWarranties;
